import ServiceRequest from '@components/sections/ServiceRequest'
import styles from './ServiceRequests.module.css'

const ServiceRequests = () => {
  return (
    <div className={styles.serviceRequests}>
      <ServiceRequest />
    </div>
  )
}

export default ServiceRequests
